import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AppV2 } from './AppV2';
import { ScoreResultsPage } from './components/ScoreResultsPage';
import './index.css';
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
const path = window.location.pathname.replace(/\/+$/, '');
function renderPage() {
  if (path === '/score') {
    return <ScoreResultsPage search={window.location.search} data-id="element-1003" data-mp="2aacmx2zjlwc1" />;
  }
  // Previous homepage retained for reference
  if (path === '/v1') {
    return <App data-id="element-1004" data-mp="2k0p4cmc299dy" />;
  }
  // Approved homepage is the default at / (and /v2 for continuity)
  return <AppV2 data-id="element-1005" data-mp="2k31mp0lqdlrj" />;
}
createRoot(rootElement).render(renderPage());